import { useEffect, useState, type ReactNode } from "react";
import { beginLogin, isAuthenticated } from "@/api/client";
import { AuthPending } from "./AuthScreens";

/** Через сколько показать кнопку ручного входа на экране «Входим…». */
const ESCAPE_AFTER_MS = 10_000;

/**
 * Гейт защищённых роутов. Лоадер уже позвал `beginLogin()` и вернул `null` —
 * значит переход на auth либо идёт, либо отложен до показа страницы (0.12+).
 *
 * Пока токена нет, элемент маршрута рендерить НЕЛЬЗЯ: `AdminLayout` без
 * principal звал `logout(true)` прямо в теле рендера — а это гасит SSO-сессию
 * всех продуктов и с 0.12 ещё и запирает `startLogin` в этом документе.
 *
 * Экран «Входим…» терминальный (лоадер роутера сам не перезапустится), поэтому
 * здесь же — два выхода из него: перезагрузка, когда токен появился (вошла
 * соседняя вкладка; возврат «Назад» из bfcache), и кнопка через 10 секунд.
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const authed = isAuthenticated();
  const [escape, setEscape] = useState(false);

  useEffect(() => {
    if (authed) return;
    const onShow = () => {
      if (isAuthenticated()) window.location.reload();
    };
    document.addEventListener("visibilitychange", onShow);
    window.addEventListener("pageshow", onShow);
    window.addEventListener("focus", onShow);
    const timer = window.setTimeout(() => setEscape(true), ESCAPE_AFTER_MS);
    return () => {
      document.removeEventListener("visibilitychange", onShow);
      window.removeEventListener("pageshow", onShow);
      window.removeEventListener("focus", onShow);
      window.clearTimeout(timer);
    };
  }, [authed]);

  if (!authed) {
    return (
      <AuthPending
        action={
          escape
            ? {
                label: "Войти заново",
                // force — иначе 5-секундное окно либы съест явный клик, если
                // перехватчик только что начал свой вход.
                onClick: () => beginLogin(undefined, { force: true }),
              }
            : null
        }
      />
    );
  }

  return <>{children}</>;
}
